import state from './state';
import * as actions from './actions';

import medicationDSS from '../encounter/questionnaires/medication-dss';
import clinicalAssessment from '../encounter/questionnaires/clinical-assessment';

/**
 * Vuex store for Medical history: MedicationDSS and Clinical Assessment
 *
 * @namespace vuex-MedicalHistory
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.4] app/src/APP_DASHBOARD/store/medical-history/index.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  namespaced: true,
  state,
  getters: {
    ...medicationDSS.reduce((accumulator, currentValue) => ({
      ...accumulator, [currentValue.key]: (state) => state[currentValue.key],
    }), {}),
    ...clinicalAssessment.reduce((accumulator, currentValue) => ({
      ...accumulator, [currentValue.key]: (state) => state[currentValue.key],
    }), {}),
  },
  mutations: {
    ...medicationDSS.reduce((accumulator, currentValue) => ({
      ...accumulator, [`SET_${currentValue.key}`]: (state, value) => {
        Object.assign(state, { [currentValue.key]: value });
      },
    }), {}),
    ...clinicalAssessment.reduce((accumulator, currentValue) => ({
      ...accumulator, [`SET_${currentValue.key}`]: (state, value) => {
        Object.assign(state, { [currentValue.key]: value });
      },
    }), {}),
  },
  actions: {
    ...actions,
    ...medicationDSS.reduce((accumulator, currentValue) => ({
      ...accumulator, [`SET_${currentValue.key}`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}`, value);
      },
    }), {}),
    ...clinicalAssessment.reduce((accumulator, currentValue) => ({
      ...accumulator, [`SET_${currentValue.key}`]: ({ commit }, value) => {
        commit(`SET_${currentValue.key}`, value);
      },
    }), {}),
  },
};
